<div class="column-form" [formGroup]="form">
  <app-simple-checkbox-value-accessor [label]="column.label" formControlName="select">
  </app-simple-checkbox-value-accessor>
</div>
